export default __webpack_public_path__ + "static/element_3-1711da64b64fbfde33e1f45f0ffd2762.png";